<div class="indicativeRate-container" *ngIf="indicativeRateCountry">
  <div class="indicative-index">1.</div>
  <div class="indicativeRateCountryLabel">
    {{ labels?.stellar?.estimate?.note }}
    {{ labels?.stellar?.estimate?.indicativeCountryHelpText }}
  </div>
</div>
